export default __webpack_public_path__ + "static/media/jquery.3bcb3b90.png";